import React, { useContext, useEffect, useState } from 'react';
import { Field, Form } from 'react-final-form';
import * as PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import toast from 'react-hot-toast';
import Select from 'react-select';
import {
  FormButtonToolbar,
  FormContainer,
  FormGroup,
  FormGroupField,
  FormGroupLabel,
} from '@/shared/components/form/FormElements';
import { Button } from '@/shared/components/Button';
import { AuthContext } from '../../../../context/AuthContext';
import { GlobalContext } from '../../../../context/GlobalContext';

const PaymentForm = ({ handleAddPayment, amount, bookingid }) => {
  const [receivedAmount, setReceivedAmount] = useState('');
  const [selectPaymentType, setSelectPaymentType] = useState(null);
  const [creditAmount, setCreditAmount] = useState();
  const [creditAmountFlag, setCreditAmountFlag] = useState(0);
  const [receivedDate, setReceivedDate] = useState(new Date());
  const [paymentStatus, setPaymentStatus] = useState({
    status: '',
  });
  const { apiGlobal } = useContext(GlobalContext);
  const { agentId, countryId } = useContext(AuthContext);

  const handleAmountCheck = (e) => {
    const value = Number(e.target.value);
    if (value > amount) {
      toast.error('Warning: Enter Amount is greater than balance');
      setReceivedAmount(0);
    } else {
      setReceivedAmount(value);
    }
  };

  const handlePaymentType = (e) => {
    setSelectPaymentType(e);
  };

  const fetchCreditAmount = async () => {
    const formData = new FormData();
    formData.append('agent_id', agentId);
     formData.append('country_id', countryId);
    try {
      const url = await fetch(`${apiGlobal}/agent/payment_on_account.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response?.status && response?.message === 'Success') {
        setCreditAmount(response?.data?.balance);
        setCreditAmountFlag(response?.data?.balance_flag);
      } else {
        setCreditAmount(0);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectPaymentType?.value === '4') {
      fetchCreditAmount();
      setReceivedDate(new Date());
    }
  }, [selectPaymentType]);


   const paymentCheckHandler = async () => {
    // console.log('hello');
        const formData = new FormData();
        formData.append('booking_id', bookingid);
        formData.append('amount', amount);
        formData.append('country_id', countryId);
          try {
            const urlString = await fetch(`${apiGlobal}/check_payment_status.php`, {
                method: 'POST',
                body: formData,
              });
            const responseData = await urlString.json();
            // console.log(responseData);
             if (responseData?.message === 'Payment Already Done.') {
              setPaymentStatus({
                status: '1',
              });
            } else {
              setPaymentStatus({
                status: '0',
              });
            }
          } catch (error) {
            console.error('🔥 Error checking payment status:', error);
            toast.error('Error checking payment status.');
          }
        };
  
       
useEffect(() => {
  if (selectPaymentType?.value === '2') {
    paymentCheckHandler();
}
}, [selectPaymentType]);
 

  return (
    <Form onSubmit={handleAddPayment} initialValue={{ selectPaymentType }}>
      {({ handleSubmit }) => (
        <FormContainer onSubmit={handleSubmit}>
          {/* <span style={{ color: 'red' }}>work in progress</span> */}
          <div className="row col-md-12">
            <div className="col-md-4">
              <FormGroup>
                <FormGroupLabel>
                  Payment Type<span className="text-danger">*</span>
                </FormGroupLabel>
                <Field
                  name="ptype"
                  render={({ input }) => (
                    <Select
                      {...input}
                      className="react-select"
                      classNamePrefix="react-select"
                      options={[
                        { value: '1', label: 'Cash' },
                        { value: '2', label: 'Pay Now' },
                        { value: '3', label: 'NEFT/RTGS/IMPS' },
                        { value: '5', label: 'Cheque' },
                        { value: '4', label: 'On Account' },
                      ]}
                      isClearable
                      placeholder="Payment Type"
                      value={input.value}
                      onChange={(e) => {
                        input.onChange(e);
                        handlePaymentType(e);
                      }}
                    />
                  )}
                />
              </FormGroup>
            </div>
          </div>

          {selectPaymentType && (
            <>
              <div className="row col-md-12">
                {selectPaymentType?.value !== '2' && (
                  <div className="col-md-4">
                    <FormGroup>
                      <FormGroupLabel>
                        Payment Date<span className="text-danger">*</span>
                      </FormGroupLabel>
                      <FormGroupField>
                        <Field
                          name="receivedDate"
                          initialValue={receivedDate}
                          render={({ input, meta }) => {
                            const isOnAccount = selectPaymentType?.value === '4';
                            const today = new Date();

                            return (
                              <>
                                <DatePicker
                                  {...input}
                                  // eslint-disable-next-line
                                  selected={input.value ? new Date(input.value) : isOnAccount ? today : null}
                                  onChange={(date) => {
                                    input.onChange(date);
                                    setReceivedDate(date);
                                  }}
                                  placeholderText="Select a date"
                                  dateFormat="dd-MM-yyyy"
                                  className="form-control"
                                  minDate={isOnAccount ? today : null}
                                  maxDate={isOnAccount ? today : null}
                                  disabledKeyboardNavigation={isOnAccount}
                                />
                                {meta.touched && meta.error && (
                                  <span className="text-danger">{meta.error}</span>
                                )}
                              </>
                            );
                          }}
                          validate={value => (value ? undefined : 'Payment date is required')}
                        />
                      </FormGroupField>
                    </FormGroup>
                  </div>
                )}

                <div className="col-md-4">
                  <FormGroup>
                    <FormGroupLabel>
                      Balance<span className="text-danger">*</span>
                    </FormGroupLabel>
                    <FormGroupField>
                      <Field
                        name="total_amount"
                        component="input"
                        type="number"
                        placeholder="Total Amount"
                        required
                        readOnly
                        initialValue={amount}
                      />
                    </FormGroupField>
                  </FormGroup>
                </div>

                {selectPaymentType?.value !== '2' && (
                  <>
                    <div className="col-md-4">
                      <FormGroup>
                        <FormGroupLabel>
                          Paid Amount<span className="text-danger">*</span>
                        </FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="recAmount"
                            type="number"
                            placeholder="Received Amount"
                            render={({ input }) => (
                              <input
                                {...input}
                                value={input.value || ''}
                                onChange={(e) => {
                                  input.onChange(e);
                                  handleAmountCheck(e);
                                }}
                                required
                              />
                            )}
                          />
                        </FormGroupField>
                      </FormGroup>
                    </div>

                    <div className="col-md-12">
                      <FormGroup>
                        <FormGroupLabel>Narration</FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="narration"
                            component="input"
                            type="text"
                            style={{ width: '100%' }}
                          />
                        </FormGroupField>
                      </FormGroup>
                    </div>

                    {selectPaymentType?.value === '4' && (
                      <FormGroup>
                        <FormGroupLabel>Running Balance</FormGroupLabel>
                        <FormGroupField>
                          <Field
                            name="creditAmount"
                            component="input"
                            type="text"
                            style={{ width: '25%', color: creditAmountFlag === 0 ? 'green' : 'red' }}
                            readOnly
                            initialValue={creditAmount}
                          />
                        </FormGroupField>
                      </FormGroup>
                    )}

                    {['2', '3'].includes(selectPaymentType?.value) && (
                      <>
                        <div className="col-md-4">
                          <FormGroup>
                            <FormGroupLabel>
                              Ref No<span className="text-danger">*</span>
                            </FormGroupLabel>
                            <FormGroupField>
                              <Field name="ref" component="input" type="text" style={{ width: '100%' }} />
                            </FormGroupField>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <FormGroupLabel>
                              Bank Name<span className="text-danger">*</span>
                            </FormGroupLabel>
                            <FormGroupField>
                              <Field name="bankName" component="input" type="text" style={{ width: '100%' }} />
                            </FormGroupField>
                          </FormGroup>
                        </div>
                      </>
                    )}

                    {selectPaymentType?.value === '5' && (
                      <>
                        <div className="col-md-4">
                          <FormGroup>
                            <FormGroupLabel>
                              Cheque No<span className="text-danger">*</span>
                            </FormGroupLabel>
                            <FormGroupField>
                              <Field
                                name="chequeNo"
                                component="input"
                                type="text"
                                style={{ width: '100%' }}
                              />
                            </FormGroupField>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <FormGroupLabel>
                              Cheque Date<span className="text-danger">*</span>
                            </FormGroupLabel>
                            <FormGroupField>
                              <Field
                                name="chequeDate"
                                className="w-100"
                                render={({ input }) => (
                                  <DatePicker
                                    {...input}
                                    selected={input.value || null}
                                    onChange={date => input.onChange(date)}
                                    dateFormat="dd-MM-yyyy"
                                  />
                                )}
                              />
                            </FormGroupField>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <FormGroupLabel>
                              Bank Name<span className="text-danger">*</span>
                            </FormGroupLabel>
                            <FormGroupField>
                              <Field name="bankName" component="input" type="text" style={{ width: '100%' }} />
                            </FormGroupField>
                          </FormGroup>
                        </div>
                      </>
                    )}
                  </>
                )}

                <span>
                  {paymentStatus.status === '1' && selectPaymentType?.value === '2' && (
                  <span style={{ color: 'red' }}>
                    (Note: Payment already done for this booking.)
                  </span>
              )}
                </span>
              </div>

              <br />
              
              <FormButtonToolbar>
                <Button 
                  variant="primary" 
                  type="submit"
                  disabled={paymentStatus.status === '1' && selectPaymentType?.value === '2'}
                >
                  Make Payment
                </Button>
                
              </FormButtonToolbar>
              
            </>
          )}
        </FormContainer>
      )}
    </Form>
  );
};

PaymentForm.propTypes = {
  handleAddPayment: PropTypes.func.isRequired,
  amount: PropTypes.string.isRequired,
  bookingid: PropTypes.string.isRequired,
};

export default PaymentForm;
